import * as yup from "yup";

const schema = yup.object({
    commentary: yup
    .string()
    .required('The field is required!')
    .test("is-validate", "The comment must be a maximum of 2000 characters", (value) => {
        if (value?.length > 0) {
            return value.length <= 2000;
        }
        return true;
    }
    ),    
});

export default schema;
